import store from '@/store'
import config from '@/config'
import lib from '@/library'
import router from '@/router'

const subscribeToLiveEvents = config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.subscribe_to_live_events
export default {
  fetchPlayerProps,
  subscribeToMarkets
}

function fetchPlayerProps (uid, idFoEventFilter = false, competition = false, isHome = false, sportType = false, isSportsPage = false) {
  if (!config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.enabled) return false
  let user = uid !== 'undefined' ? uid : 0
  const selectionCount = config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.selection_count
  const eventCount = config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.event_count
  let location = router.currentRoute.name !== 'event' ? 'widget:playerprops' : null
  let args = {}
  args.uid = user
  args.selectionCount = selectionCount
  args.location = location
  if (isHome) {
    args.eventCount = eventCount
  } else if (!isHome && competition && competition.length > 0 && isSportsPage) {
    args.competitionId = competition[0]
    args.eventCount = eventCount
  } else if (!isHome && sportType && (!competition || competition.length === 0) && isSportsPage) {
    args.sportTypeId = sportType
    args.eventCount = eventCount
  } else if (!isHome && idFoEventFilter && !isSportsPage) {
    args.idFoEventFilter = idFoEventFilter
  }
  lib.rpcService.callBroker('personalization', 'getrecommendedselections', args)
      .then(response => {
        let playerProps = response && response.result ? response.result : {}
        if (JSON.stringify(playerProps) === '{}') {
          store.commit('playerPropsState/setIsPlayerPropsEmpty', true)
          return false
        } else {
          store.commit('playerPropsState/setIsPlayerPropsEmpty', false)
        }
        store.commit('playerPropsState/setPlayerProps', playerProps)
      })
      .catch(error => {
        console.error('Popular Parlays fetch error:', error)
        store.commit('playerPropsState/setPlayerProps', [])
        store.commit('playerPropsState/setIsPlayerPropsEmpty', true)
      })
      .finally(() => {
        store.commit('playerPropsState/setIsLoading', false)
        store.commit('featureTabsState/setIsLoading', false)
        store.commit('playerPropsState/setExpansionPanel', 0)
        store.commit('playerPropsState/setLoadPlayerPropsComplete')
      })
}

function subscribeToMarkets (events) {
  if (events && events.length && subscribeToLiveEvents) {
    let getLiveEvents = store.getters['livebettingState/liveEvents']
    filteredByLiveEvents(events, getLiveEvents)
  }
}

function filteredByLiveEvents (events, liveEvents) {
  let hasLiveEvents = events.filter(event => liveEvents.some(live => live.idfoevent === event.idfoevent))
  if (hasLiveEvents.length > 0) {
    let getAllMarkets = hasLiveEvents.flatMap(event => event.markets)
    lib.WebSocketLiveService.subscribeToMarketsByIDFOMarkets(getAllMarkets)
  }
}



// WEBPACK FOOTER //
// ./src/library/personalization/playerProps.js